export default __webpack_public_path__ + "static/media/contact.b6f9a1bd.png";